import Framework7, { Dom7 as $ } from "framework7/bundle";
import "framework7/css/bundle";
import "framework7-icons/css/framework7-icons.css";
import "material-icons/iconfont/material-icons.css";
import "../css/slideToUnlock.css";
import "../css/accordion.css";
import "../css/app.css";
import "../css/skin.css";

import routes from "./routes.js";
import { APIUrl } from "./config.js";
import { readItem, writeItem, checkSettings } from "./storage.js";
import { localizeStr, locales } from "./i18n.js";
import { adjustScreen, setTheme, setHeight, isEmail, getSavedResult, applySavedResults } from "./ui.js";
import { api, legacyRequest } from "./api.js";
import { installAuthHandlers, login, logout, readProfilePicture } from "./auth.js";
import { installMedianBridge } from "./median.js";
import { installThesaurus, openThesaurus, closeThesaurus } from "./thesaurus.js";
import { installSession, isLoggedIn, apiError, onUnauthorized as handleUnauthorized } from "./session.js";
import { onUnauthorized } from "./api.js";
import { documentCount, openDocument } from "./documents.js";
import { installNotes, openNoteDialog, saveNote, updateNote, deleteNote, arrangeNotes } from "./notes.js";
import { getAddress, getFormatedAddress, initMap, getCurrentPosition, getGeolocationPermission, reverseGeocode } from "./geoLocation.js";
import * as therapy from "./therapy.js";

// ---------------------------------------------------------------------------
// Uebergangs-Shim: Die Seiten in public/pages und public/panels werden zur
// Laufzeit vom Router kompiliert und greifen auf diese Namen als Globals zu.
// Alles, was hier steht, ist eine Altlast; mit dem Umbau der Seiten auf
// eigene Importe (Etappe 2) wird die Liste kuerzer, bis sie leer ist.
// ---------------------------------------------------------------------------
Object.assign(window, {
    $,
    APIUrl,
    readItem,
    writeItem,
    checkSettings,
    localizeStr,
    locales,
    adjustScreen,
    setTheme,
    setHeight,
    isEmail,
    getSavedResult,
    applySavedResults,
    login,
    logout,
    isLoggedIn,
    apiError,
    readProfilePicture,
    openThesaurus,
    closeThesaurus,
    openNoteDialog,
    documentCount,
    openDocument,
    saveNote,
    updateNote,
    deleteNote,
    arrangeNotes,
    getAddress,
    getFormatedAddress,
    initMap,
    getCurrentPosition,
    getGeolocationPermission,
    reverseGeocode,
    ...therapy
});

const app = new Framework7({
    name: "SwissDTx",
    theme: "ios",
    el: "#app",
    routes,
    view: {
        // Echte Pfade statt /#!/pfad: der Trenner ist standardmaessig "#!".
        // Der Server muss dafuer jeden Pfad auf index.html fallen lassen
        // (Vite tut das im Dev-Server; nginx braucht try_files).
        browserHistory: true,
        browserHistorySeparator: "",
        browserHistoryRoot: ""
    },
    popover: {
        // Kontextmenues ohne Abdunkeln der Seite, wie das alte Menu
        backdrop: false
    },
    navbar: {
        hideOnPageScroll: true,
        showOnPageScrollEnd: false,
        showOnPageScrollTop: false
    }
});

// Altes app.request-Interface fuer die noch nicht umgebauten Seiten.
app.request = legacyRequest;
window.app = app;
window.api = api;

installAuthHandlers(app);
installSession(app);
onUnauthorized(handleUnauthorized);
installThesaurus(app);
installNotes(app);
installMedianBridge(app);

app.on("pageInit", function () {
    adjustScreen();
    setTheme();
});

app.on("panelOpened", function () {
    adjustScreen();
});

export default app;
